export default __webpack_public_path__ + "static/media/post_img_2.64da827f.png";